import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import { Text, MainButton } from '@bizzabo/design-system';
import { UserData } from '@bizzabo/entities';

interface WelcomeCardProps {
    isFirstTime: boolean;
    user: UserData;
    removeCard: () => void;
}
const WelcomeCard: React.FC<WelcomeCardProps> = ({ isFirstTime, user, removeCard }) => {
    const classes = useStyles();

    return (
        <div className={cn(classes.cardContainer, { hide: !isFirstTime })}>
            <div className={classes.card}>
                <div className={classes.title}>
                    <Text variant="t50">{`Hi ${user.firstName}`}</Text>
                    <span className={classes.emoji}>👋</span>
                </div>
                <Text variant="t81" className={classes.text}>
                    Get more from the event! Share ideas, learn new things and discover business
                    opportunities. Start networking by exploring, sending messages and meet with
                    people around you
                </Text>
                <div className={classes.btnContainer}>
                    <MainButton variant="fill" className={classes.btn} onClick={removeCard}>
                        Got it!
                    </MainButton>
                </div>
            </div>
        </div>
    );
};
const useStyles = makeStyles(
    theme => ({
        cardContainer: {
            maxHeight: 243,
            overflow: 'hidden',
            transition: 'all 0.2s linear',
            '&.hide': {
                maxHeight: 0,
            },
        },
        card: {
            margin: '0 24px 24px',
            padding: 24,
            borderRadius: 16,
            backgroundColor: theme.palette.greys[200],
        },
        title: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: theme.palette.greys[700],
        },
        text: {
            margin: '10px 0 20px',
            textAlign: 'center',
            color: theme.palette.greys[600],
        },
        emoji: {
            marginBottom: 6,
            marginLeft: 4,
            fontSize: '1.6rem',
        },
        btnContainer: {
            display: 'flex',
            justifyContent: 'center',
        },
        btn: {
            ...theme.typography.t80,
            height: 24,
            padding: '0 13px',
        },
    }),
    { classNamePrefix: WelcomeCard.name }
);
export default WelcomeCard;
